import { useQuery } from 'react-query'
import { config } from 'config'
import { AuthContainer } from 'containers'
import { callAxios, CustomAxiosError } from 'utils/api'
import { getParamsForAll, getQueryParamsForAll } from 'utils/hooks'

const { SECURE_BASE_URL } = config!

export type CategoryResponse = { commercial_category: string }[]

type GetCategoryRequest = {
  vendorNumber: string
  division: string[]
  reportName?: string
}

const getCategory = async (props: GetCategoryRequest): Promise<CategoryResponse> => {
  const { vendorNumber, division, reportName } = props

  let queryParams = `vendornumber=${vendorNumber}`

  queryParams = getQueryParamsForAll(queryParams, 'commercial_division', division)

  if (reportName) queryParams += `&reportname=${reportName}`

  const { response: categoryResponse } = await callAxios<{
    response: { data: CategoryResponse }
  }>({
    url: `${SECURE_BASE_URL}/category?${queryParams}`,
    method: 'GET',
  })

  const filteredCategoryResponse = categoryResponse.data?.filter((item) => !!item.commercial_category)

  return filteredCategoryResponse
}

export const useGetCategory = (props: Omit<GetCategoryRequest, 'vendorNumber'>) => {
  const { division, reportName } = props
  const { selectedSupplier } = AuthContainer.useContainer()
  const vendorNumber = selectedSupplier?.oracleId ?? ''

  const isEnabled = !!vendorNumber && !!division.length

  const {
    status: getCategoryStatus,
    isFetching: getIsCategoryLoading,
    data: categoryData,
    error: getCategoryError,
  } = useQuery<CategoryResponse, CustomAxiosError>(
    ['category/get', vendorNumber, getParamsForAll(division, 'only'), reportName],
    () => getCategory({ ...props, vendorNumber }),
    { enabled: isEnabled }
  )

  return {
    getCategoryStatus,
    getIsCategoryLoading,
    categoryData,
    getCategoryError,
  }
}
